package com.nonopn.skywatcher.common.app.pages.map.model.weather

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.ui.graphics.vector.ImageVector

enum class SortBy {
    Distance,
    Strength,
    Time
}

enum class SortOrder(val icon: ImageVector) {
    Asc(Icons.Default.KeyboardArrowDown),
    Desc(Icons.Default.KeyboardArrowUp);

    inline fun <T, R : Comparable<R>> sort(
        list: Iterable<T>,
        crossinline selector: (T) -> R?
    ) = when (this) {
        Asc -> list.sortedBy(selector)
        Desc -> list.sortedByDescending(selector)
    }

    fun next() = when (this) {
        Asc -> Desc
        Desc -> Asc
    }
}

data class SortByInstance(
    val sortBy: SortBy = SortBy.Time,
    val order: SortOrder = SortOrder.Asc
) {
    fun next(sortBy: SortBy) = if (sortBy == this.sortBy) {
        copy(order = order.next())
    } else {

        SortByInstance(sortBy, order)
    }
}